import { CustomUseInfiniteQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { ApiInstance, RequireOnly, UserPositions, UserPositionsParams } from '@/libs/sdk/api';
import { keepPreviousData } from '@tanstack/react-query';
import { useSSEInfiniteQuery } from '../hooks/use-sse-query';

export const useUserPositions = (
  api: ApiInstance,
  searchParams: RequireOnly<UserPositionsParams, 'uid' | 'baseTokenAddress'>,
  options?: CustomUseInfiniteQueryOptions<UserPositions>
) => {
  const { page = 1, pageSize = 10 } = searchParams || {};
  const { queryKey, enabled = true, ...rest } = options || {};

  return useSSEInfiniteQuery(
    api.sse,
    {
      ...rest,
      enabled: enabled && hasNonEmptyProp(searchParams, ['uid', 'baseTokenAddress']),
      queryKey: [queryKey, 'UserPositions', searchParams],
      initialPageParam: { page, pageSize },
      queryFn: async ({ pageParam }) => {
        const { data } = await api.market.getUserPositions({ ...searchParams!, ...pageParam });
        return { ...data, ...pageParam };
      },
      placeholderData: keepPreviousData,
    },
    [{ event: 'user:position_changed' }]
  );
};
